<template>
  <v-dialog
    v-model="show"
    max-width="300px"
  >
    <template #activator="{ on }">
      <slot v-bind="{ on }">
        <span v-on="on">Default</span>
      </slot>
    </template>

    <v-card>
      <v-card-title>
        Are you sure?
      </v-card-title>

      <v-card-actions>
        <v-btn
          text
          @click="show = false"
        >
          Cancel
        </v-btn>

        <v-spacer />

        <v-btn
          depressed
          color="error"
          @click="$emit('confirm')"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      show: false
    }
  }
}
</script>
